export default "__VITE_ASSET__P0p8dFf8__"